'use strict';

module.exports = {
    current: 'Current',
};
